import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { categories } from '../../data/categories';
import { products } from '../../data/products';
import { ProductCard } from '../shop/ProductCard';
export function ShopPreview() {
  const popular = products.filter(product => product.popular).sort((a, b) => a.name.localeCompare(b.name)).slice(0, 4);
  return <section className="bg-cream-light" data-id="element-79" data-mp="3qwedqk5c4eau">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-80" data-mp="3qta6tf0hj4gh">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-81" data-mp="3lup335m0y2na">
          <div data-id="element-82" data-mp="3gwf92yc1d839">
            <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-83" data-mp="3gxypcoxozj51">What we treat</p>
            <h2 className="mt-3 max-w-xl font-serif text-3xl font-bold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-84" data-mp="3cwwx4s2707ck">
              Start with what you are actually trying to fix.
            </h2>
          </div>
          <Link to="/shop" className="group inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-85" data-mp="1b50bgpmb9h42">
            See everything
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-86" data-mp="36slihpbn7wir" />
          </Link>
        </div>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-87" data-mp="2wxtk4ja8l5mx">
          {categories.map(category => <li key={category.slug} data-id="element-88" data-mp="3kmwaqgmum8tk">
              <Link to={`/categories/${category.slug}`} className="group flex h-full items-center justify-between gap-4 rounded-brand border border-ink/10 bg-cream p-5 transition-colors duration-150 ease-republic hover:border-ink/40" data-id="element-89" data-mp="3plfymml05uok">
                <span data-id="element-90" data-mp="3ftjna9two82e">
                  <span className="block font-serif text-lg font-semibold text-ink" data-id="element-91" data-mp="7g3014as8tdp">
                    {category.name}
                  </span>
                  <span className="mt-1 block text-sm text-ink-muted" data-id="element-92" data-mp="c7ck7pdkb4i7">{category.tagline}</span>
                </span>
                <ArrowRightIcon className="h-5 w-5 shrink-0 text-brick transition-transform duration-200 ease-republic group-hover:translate-x-1" strokeWidth={1.75} data-id="element-93" data-mp="m1qj0m591ruz" />
              </Link>
            </li>)}
        </ul>

        <div className="rule mt-14 pt-8" data-id="element-94" data-mp="81z2oer9fzdt">
          <h3 className="text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-95" data-mp="33noxsxuh4qb">
            What members ask for most
          </h3>
          <ul className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-96" data-mp="3uhaabfmd107e">
            {popular.map(product => <ProductCard key={product.slug} product={product} data-id="element-97" data-mp="3qhjdau68pnuf" />)}
          </ul>
        </div>
      </div>
    </section>;
}